const CALLBACK_GETTERS = Object.freeze(Object.assign(Object.create(null), {
  on_open: (options) => options.on_open,
  on_close: (options) => options.on_close,
  on_error: (options) => options.on_error,
  on_event: (options) => options.on_event,
}));

export function get_websocket_callback(options, name) {
  if (!Reflect.has(CALLBACK_GETTERS, name)) return null;
  const getter = Reflect.get(CALLBACK_GETTERS, name);
  return typeof getter === "function" ? getter(options || {}) : null;
}

export function invoke_websocket_callback(options, name, payload) {
  const callback = get_websocket_callback(options, name);
  if (typeof callback === "function") callback(payload);
}
